import React from 'react';
import imgUrl from "../assets/codingBg.jpg";

const divStyle = {
  height: 'auto',
  width: '100%',
  backgroundImage: 'url(' + imgUrl + ')',
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
};
const heroText = {
  color: 'white',
  fontWeight: 900,
  fontSize: '2rem',
}

const Home = (props) => {

  const handleClickScroll = (val) => {
    const element = document.getElementById(val);
   
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

    return (
        <section className="hero" style={divStyle} id={props.id}>
        <div className="hero min-h-screen heroDiv">
          <div className="hero-overlay bg-opacity-600 "></div>
          <div className="hero-content text-center text-neutral-content">
            <div className="max-w-lg" style={heroText}>
              <h1 className="mb-5 text-3xl">Hello, I am a <span className='text-blue-400'>Full Stack Software Developer</span>.</h1>
              <p className="mb-5 text-2xl">My name is <span className='text-blue-400'>Fhatuwani Raphalalani.</span> Welcome</p>
       
              <button
                className="btn btn-primary"
                onClick={() => handleClickScroll("portfolio")}
              >
                Explore More
              </button>
            </div>
          </div>
        </div>
      </section>
    )
}

export default Home;
